// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__dGVno","label":"NotFound_label__23mS0","description":"NotFound_description__uwGiC","title":"NotFound_title__ZO3Rm"};